export default __webpack_public_path__ + "static/media/partners2.dc717db5.png";